<template>
    <Modal size="m">
        <div class="baggage-warning">
            <Illustration :data="{ type: 'Baggage4' }" class="baggage-warning-illustration" />
            <div class="baggage-warning-description">
                <Element font="font-heading-5" class="baggage-warning-description-header">
                    {{
                        t({
                            key: 'warning.do_you_want_extra_baggage',
                        })
                    }}
                </Element>
                {{
                    t({
                        key: 'warning.save_up_to_by_adding_baggage_during_booking',
                    })
                }}
            </div>
            <div class="baggage-warning-buttons">
                <ButtonPrimary :onClick="onShowAlternativesClick">
                    {{ t({ key: 'warning.show_alternatives' }) }}
                </ButtonPrimary>
                <ButtonSecondary :onClick="onSkipClick">
                    {{ t({ key: 'warning.skip' }) }}
                </ButtonSecondary>
            </div>
        </div>
    </Modal>
</template>

<script lang="ts">
    import { defineComponent, onMounted } from 'vue';
    import { useStore } from '@/store';
    import { t } from '@shared/helpers/translation';
    import { scrollToElement } from '@shared/helpers/scroll';
    import {
        logStatsigCheckoutBaggageWarningInteraction,
        logStatsigCheckoutBaggageWarningOpen,
    } from '@/tracking/statsig/checkout.functions';
    import {
        BaggageWarningInteraction,
        BaggageWarningPosition,
    } from '@/tracking/statsig/types';
    import Modal from '@ui/components/Modal/Modal.vue';
    import ButtonSecondary from '@ui/components/Button/ButtonSecondary.vue';
    import ButtonPrimary from '@ui/components/Button/ButtonPrimary.vue';
    import Element from '@ui/components/Element/Element.vue';
    import Illustration from '@ui/components/Illustration/Illustration.vue';

    export default defineComponent({
        name: 'BaggageWarningModal',
        components: {
            Illustration,
            Element,
            Modal,
            ButtonPrimary,
            ButtonSecondary,
        },
        methods: { t },
        props: {
            onSkip: { type: Function },
        },
        setup(props) {
            const store = useStore();

            onMounted(() => {
                logStatsigCheckoutBaggageWarningOpen(BaggageWarningPosition.Global);

                store.dispatch('general/setPromptedBaggageGlobal', true);
            });

            const onShowAlternativesClick = () => {
                const firstBaggageSection = document.body.querySelector(
                    '.checkout-flight-pax-baggage'
                );
                firstBaggageSection && scrollToElement(firstBaggageSection, -20, true);
                logStatsigCheckoutBaggageWarningInteraction(
                    BaggageWarningPosition.Global,
                    BaggageWarningInteraction.ShowAlternatives
                );
                hideModal();
            };

            const onSkipClick = () => {
                props.onSkip && props.onSkip();
                logStatsigCheckoutBaggageWarningInteraction(
                    BaggageWarningPosition.Global,
                    BaggageWarningInteraction.Skip
                );
                hideModal();
            };

            const hideModal = () => {
                store.dispatch('general/setModal', null);
            };

            return { onShowAlternativesClick, onSkipClick };
        },
    });
</script>

<style lang="scss" scoped>
    @forward 'BaggageWarning';
</style>
